import * as React from "react";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  ReferralsHistory as ReferralsHistoryComponent,
  ReferralsHistoryProps,
} from "../../components/ReferralsHistory/ReferralsHistory";
import { getSharesAction, resendShare } from "../../actions";
import { StoreState } from "../../reducers";
import { getIsLoadingShares, getShares } from "../../reducers/share/methods";

interface ReferralsHistoryContainerProps extends ReferralsHistoryProps {
  getSharesAction: typeof getSharesAction;
  resendShare: typeof resendShare;
  shares: ReturnType<typeof getShares>;
}

class ReferralsHistory extends React.Component<ReferralsHistoryContainerProps> {
  componentDidMount() {
    const isCustomerAuthenticated = get(
      this.props.data,
      "customer.authenticated",
      false
    );

    if (isCustomerAuthenticated) {
      this.props.getSharesAction();
    }
  }

  render() {
    return <ReferralsHistoryComponent {...this.props} />;
  }
}

const mapStateToProp = (state: StoreState) => ({
  isLoading: getIsLoadingShares(state.share),
  shares: getShares(state.share),
});

export default connect(mapStateToProp, { getSharesAction, resendShare })(
  ReferralsHistory
);
